import { supabase } from '../lib/supabase'

const supabaseUrl = process.env.SUPABASE_URL
const publishableKey = process.env.SUPABASE_PUBLISHABLE_KEY
export const portalOrganizationId = process.env.CSPAH_ORGANIZATION_ID

async function edgeRequest(functionName, { body, token } = {}) {
  const response = await fetch(supabaseUrl + '/functions/v1/' + functionName, {
    method: 'POST',
    headers: {
      apikey: publishableKey,
      'Content-Type': 'application/json',
      ...(token ? { Authorization: 'Bearer ' + token } : {}),
    },
    body: JSON.stringify(body ?? {}),
    cache: 'no-store',
  })
  const result = await response.json().catch(() => ({}))
  if (!response.ok) throw Object.assign(new Error(result.error || 'No fue posible completar la operación.'), { status: response.status })
  return result
}

async function adminFunction(functionName, body) {
  const { data, error } = await supabase.functions.invoke(functionName, { body })
  if (error) throw new Error(error.context?.error || error.message || 'No fue posible completar la operación.')
  if (data?.error) throw new Error(data.error)
  return data
}

export function portalLogin(rut, pin) {
  if (!portalOrganizationId) throw new Error('El portal no está configurado.')
  return edgeRequest('cp-portal-login', { body: { organizacion_id: portalOrganizationId, rut, pin } })
}

export function obtenerPortalSocio(token) {
  return edgeRequest('cp-portal-me', { token })
}

export function actualizarPerfilPortal(token, payload) {
  return edgeRequest('cp-portal-actualizar-perfil', { token, body: payload })
}

export async function listarConsultasPortal(token) {
  return (await edgeRequest('cp-portal-consultas', { token, body: { action: 'listar' } })).consultas
}

export async function crearConsultaPortal(token, categoria, consulta) {
  return (await edgeRequest('cp-portal-consultas', { token, body: { action: 'crear', categoria, consulta } })).consultas
}

export function cerrarSesionPortal(token) {
  return edgeRequest('cp-portal-logout', { token })
}

export function validarCredencialQr(token) {
  return edgeRequest('cp-validar-socio-qr', { body: { token } })
}

export function obtenerEstadoCredencial(organizacionId, socioId) {
  return adminFunction('cp-admin-socio-credencial', { organizacion_id: organizacionId, socio_id: socioId, action: 'status' })
}

export function regenerarQrSocio(organizacionId, socioId) {
  return adminFunction('cp-admin-socio-credencial', { organizacion_id: organizacionId, socio_id: socioId, action: 'regenerate_qr' })
}

export function cambiarAccesoPortal(organizacionId, socioId, activo) {
  return adminFunction('cp-admin-socio-credencial', { organizacion_id: organizacionId, socio_id: socioId, action: 'set_portal_access', activo })
}